module.exports = __webpack_public_path__ + "static/media/phones_2@2x.79a345bc.png";